/**
 * Query keys for trajectory paths
 * Organized by entity and operation
 */
export const TRAJECTORY_PATHS_QUERY_KEYS = {
  all: ['trajectory-paths'] as const,
  details: () => [...TRAJECTORY_PATHS_QUERY_KEYS.all, 'detail'] as const,
  detail: (trajectoryId: string) =>
    [...TRAJECTORY_PATHS_QUERY_KEYS.details(), trajectoryId] as const,
}
